<script>
import Calculator from '../../components/tank-management/calculator/Calculator.vue';

export default{
    props: [''],
    components: {
        Calculator
    },
    data(){
        return{ 
            data: {
                
            },
            // inputData: {
            //     date: null,
            //     tankId: null,
            //     tankStatus: null,
            //     productId: null,   
            //     type: null,           
            // },
            // tankDevelopmentData: {
            //     datiIngresso: {
            //         level: null,
            //         fullEmpy: null,
            //         tempCalib: null,
            //         tempAmb: null,
            //         tempLiq:null,
            //         density:null,
            //         levWater: null,
            //         footPosition:null,
            //         tempGas:null,
            //         datiIngressoRadio:null,
            //     },
            //     results:{
            //             tempMant:null,
            //             deltaTemp:null,
            //             volLordo:null,
            //             volAcqua:null,
            //             coeffDilatTerm:null,
            //             volLordoH2o:null,
            //             volTetto:null,
            //             volNetto:null,
            //             coeffFX54:null,
            //             vol15:null,
            //             coeffFX56:null,
            //             pesoGiacenza:null,
            //             livelloApieno:null,
            //             volEstraib:null,
            //             pesoEstraib:null,
            //             volVapore:null,
            //             pesoVapore:null,
            //     },
            //     iniziale:{
            //             tempMant:null,
            //             vol15:null,
            //             deltaTemp:null,
            //             coeffFX56:null,
            //             volLordo:null,
            //             pesoGiacenza:null,
            //             volAcqua:null,
            //             livelloApieno:null,
            //             coeffDilatTerm:null,
            //             volEstraib:null,
            //             volLordoH2o:null,
            //             pesoEstraib:null,
            //             volTetto:null,
            //             volVapore:null,
            //             volNetto:null,
            //             pesoVapore:null,
            //             coeffFX54:null,
            //     },
            //     finale:{
            //             tempMant:null,
            //             vol15:null,
            //             deltaTemp:null,
            //             coeffFX56:null,
            //             volLordo:null,
            //             pesoGiacenza:null,
            //             volAcqua:null,
            //             livelloApieno:null,
            //             coeffDilatTerm:null,
            //             volEstraib:null,
            //             volLordoH2o:null,
            //             pesoEstraib:null,
            //             volTetto:null,
            //             volVapore:null,
            //             volNetto:null,
            //             pesoVapore:null,
            //             coeffFX54:null,
            //     },
            //     finalresult:{
            //         tempMant:null,
            //         vol15:null,
            //         deltaTemp:null,
            //         coeffFX56:null,
            //         volLordo:null,
            //         pesoGiacenza:null,
            //         volAcqua:null,
            //         livelloApieno:null,
            //         coeffDilatTerm:null,
            //         volEstraib:null,
            //         volLordoH2o:null,
            //         pesoEstraib:null,
            //         volTetto:null,
            //         volVapore:null,
            //         volNetto:null,
            //         pesoVapore:null,
            //         coeffFX54:null,
            //         coeffFX54:null,
            //     }
            // },
            // dischargeDevelopmentData: {
            //     type:null,
            //     datiMisureIniziali:{
            //     livelloApieno:null,
            //     levWater:null,
            //     tempCalib:null,
            //     tempAmb:null,
            //     tempLiq:null,
            //     },
            //     datiBarilotto:{
            //         density:null,
            //         contAcqua:null,
            //         sediments:null,
            //         contAcquaSediments:null,
            //     },
            //     datiAccertamentoIniziale:{
            //         vol15:null,
            //         pesoGiacenza:null,
            //         density:null,
            //     },
            //     datiAccertamentoInizialeRicalcolati:{
            //         coeffFX54:null,
            //         volNetto:null,
            //     },
            //     densitaMediaPonderale:{
            //         volLordoTetto:null,
            //         densityMed:null,
            //         coeffFX54:null,
            //         coeffFX56:null,
            //         volTetto:null,
            //     },
            //     datiLordiAccertamentoFinale:{
            //         tempMant:null,   
            //         deltaTemp:null,
            //         volLordo:null,
            //         volAcqua:null,
            //         coeffDilatTerm:null,
            //         volLordoAcqua:null,
            //         coeffFX56:null,
            //         volTetto:null,
            //         volLordoTetto:null,
            //         volIntr:null,
            //     },
            //     datiNettiAccertamentoFinale:{
            //         SW:null,
            //         coeffsSW:null,
            //         volIntr:null,
            //         SWLt:null,
            //         vol15:null,
            //         Qta:null,
            //         pesoGiacenza:null,
            //         volEstraib:null,
            //         pesoEstraib:null,
            //     },
            // }
        }
    },
    mounted(){
    },
    computed: {
    },
    methods: {
    }
};
</script>

<template>
    <main>

        <Calculator />
    </main>
</template>

<style>

</style>